module.exports = __webpack_public_path__ + "img/ywAward-5.483c5ac4.png";